export const STORE_ROUTING_FLAG = 'ecomm.delivery.nearest-store-routing.rollout';

export type StoreRoutingOutcome =
  | 'aborted'
  | 'accepted'
  | 'declined'
  | 'in_progress'
  | 'navigation_failed'
  | 'not_offered'
  | 'superseded'
  | 'transition_failed';

export const didStoreRoutingHandleSource = (outcome: StoreRoutingOutcome): boolean =>
  outcome === 'accepted' ||
  outcome === 'in_progress' ||
  outcome === 'navigation_failed' ||
  outcome === 'superseded' ||
  outcome === 'transition_failed';
